import { FEATURES } from "../../../mocks/gossip";
import { SectionHead } from "./Shared";

export default function FeatureSection() {
  return (
    <section
      id="feature"
      className="w-full bg-background-100/70 py-10 md:py-14"
      aria-label="深度专题报道"
    >
      <div className="container-x">
        <SectionHead
          eyebrow="FEATURE · 深度专题"
          anchor="feature"
          title="不只是瓜：把热闹背后的门道讲清楚"
          desc="除了即时资讯，我们也做能让你慢下来的长篇。用时间线与行业视角，复盘那些看似突然、其实早有伏笔的热点事件。"
        />

        <div className="space-y-6">
          {FEATURES.map((f, i) => (
            <article
              key={f.index}
              className="group grid grid-cols-1 items-center gap-0 overflow-hidden rounded-2xl border border-background-200 bg-background-50 md:grid-cols-2"
            >
              <div
                className={`relative aspect-[16/10] w-full overflow-hidden md:aspect-auto md:h-full md:min-h-[320px] ${
                  i % 2 === 1 ? "md:order-2" : ""
                }`}
              >
                <img
                  src={f.image}
                  alt={f.title}
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-4 top-4 font-label text-4xl font-bold text-background-50/90 md:text-5xl">
                  {f.index}
                </span>
              </div>
              <div className={`p-6 md:p-10 ${i % 2 === 1 ? "md:order-1" : ""}`}>
                <div className="flex items-center gap-2">
                  <span className="inline-flex items-center gap-1 rounded-full bg-accent-100 px-2.5 py-1 text-xs font-semibold text-accent-800">
                    <i className="ri-article-line text-[13px]" />
                    深度专题
                  </span>
                  <span className="flex items-center gap-1 text-xs text-foreground-500">
                    <i className="ri-time-line" />
                    约 {f.readTime} 阅读
                  </span>
                </div>
                <h3 className="mt-4 font-heading text-xl font-black leading-snug text-foreground-950 md:text-2xl">
                  {f.title}
                </h3>
                <p className="mt-3 text-sm leading-7 text-foreground-600 md:text-[15px]">{f.summary}</p>
                <div className="mt-6 flex flex-wrap items-center gap-3">
                  <a
                    href="#today"
                    className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
                  >
                    阅读全文 <i className="ri-arrow-right-line" />
                  </a>
                  <span className="text-xs text-foreground-400">本期为专题第一期 · 持续连载中</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}